import Repository from "@/apis/Repository.js";

const GET_ALL = "getAll";
const ADD = "add";
const EDIT_TAG = "edit";
const DELETE_TAG = "delete";

export default {
  getTags(payload) {
    return Repository.post(transformRoute(GET_ALL), payload);
  },

  getSingleTag(payload) {
    return Repository.get(transformRoute(payload));
  },

  addTag(payload) {
    return Repository.post(transformRoute(ADD), payload);
  },
  deleteTag(payload) {
    return Repository.post(transformRoute(DELETE_TAG), payload);
  },
  editTag(payload) {
    return Repository.post(transformRoute(EDIT_TAG), payload);
  },
};

const transformRoute = (route = "") => {
  return `/cms/tag/${route}`;
};
